
import { Component, Vue, Inject } from "vue-property-decorator";
import DZServiceAgentUser from "@/views/代理商管理/service/DZServiceAgentUser";
import ny_config from "@/api/nyConfig";
import api from "@/api/nyApiJson";
import DZModelProcess from "@/views/代理商管理/model/DZModelProcess";
import nyNetwork from "@/api/nyBaseNetwork";
import DZSearchAgentUser from "@/views/代理商管理/model/DZSearchAgentUser";

@Component({
    components: {}
})
export default class Index extends Vue {

    excelName = '代理商列表'

    $refs: any;

    table_height = 0;

    dialog_show = false;

    created() {
        this.action_list_data()
    }

    mounted() {
        this.$nextTick(() => {
            const mainHeight = this.$refs.mainContent.offsetHeight;
            const mainScreen = this.$refs.mainScreen.offsetHeight;
            this.table_height = mainHeight - mainScreen - 50;
        })
    }

    bindImage(id) {
        if (!id) {
            return "";
        }
        let apiName = "显示图片";
        let apiJson: ny_config = api[apiName];
        let url = apiJson.baseUrl + apiJson.url + "?image=" + id
        return url;
    }

    bindStatus(n){
        if(n == 0){
            return '未审核'
        }else if( n == 1){
            return '审核通过'
        }else if( n == 2 ){
            return '审核未通过'
        }else if( n == -1 ){
            return '禁用'
        }
    }

    s_serve = new DZServiceAgentUser();

    action_list_data(){
        let arr = this.s_serve.m_search.countyArr
        if(arr.length != 0){
            this.s_serve.m_search.level = String(arr.length)
            this.s_serve.m_search.cityId = arr[arr.length-1]
        }
        this.s_serve.net_user_list()
    }

    clean(){
        this.s_serve.m_search = new DZSearchAgentUser(10);
        this.action_list_data()
    }

    handle_process(id){
        if(id){
            this.s_serve.m_process = new DZModelProcess();
            this.s_serve.m_process.userId = id
            this.dialog_show = true
        }
    }

    dialog_close(){
        this.dialog_show = false
    }

    action_operate_user(){
        this.s_serve.net_operate_user(this.action_list_data)
        this.dialog_show = false
    }

    handleSizeChange(val){
        this.s_serve.m_search.pageSize = val
        this.action_list_data()
    }

    json_fields = {
        '手机':'phone',
        '邮箱':'email',
        '微信':'wxNum',
        '代理地区':'agentCity',
        '状态':'status',
        '备注':'content'
    }

    selections = []
    handleSelectionChange(val) {
        let arr = JSON.parse(JSON.stringify(val))
        arr.map(a=>{
            a.status = this.bindStatus(a.status)
        })
        this.selections = arr;
    }

    toPrint(){
        this.$nyPrint.printTable(this.selections,this.json_fields,this.excelName)
    }

    el_cascader_props = {
        lazy: true,
        checkStrictly: true,
        lazyLoad (node, resolve) {
            const { level,value } = node;
            let id = 0
            if(level != 0){
                id = value
            }
            nyNetwork.net("城市列表",{pid:id}, data => {
                const nodes = data.map(i=>{
                    return {
                        value:i.id,
                        label:i.name,
                        leaf:level>=1
                    }
                })
                resolve(nodes)
            })
        }
    }
}
